import React from 'react';
import Prism from 'prismjs';
import { Highlight, Prism as PrismRR } from 'prism-react-renderer';
import rangeParser from 'parse-numeric-range';

import { Button } from '../ui/button';

type PrismLib = typeof PrismRR & typeof Prism;

const calculateLinesToHighlight = (raw) => {
  const lineNumbers = rangeParser(raw);
  if (lineNumbers) {
    return (index) => lineNumbers.includes(index + 1);
  } else {
    return () => false;
  }
};

const copyToClipboard = (str) => {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(str).then(
      function () {
        console.log('Copying to clipboard was successful!');
      },
      function (err) {
        console.error('Could not copy text: ', err);
      },
    );
  } else if (window.clipboardData) {
    // Internet Explorer
    window.clipboardData.setData('Text', str);
  }
};

const Code: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [isCopied, setIsCopied] = React.useState(false);
  const className = children.props.className || '';
  const code = children.props.children.trim();
  const language = className.replace(/language-/, '');
  const file = children.props.file;
  const highlights = calculateLinesToHighlight(children.props.highlights || '');

  return (
    <div className='bg-black text-white rounded my-8 pl-6'>
      <div className='flex relative'>
        <div className='bg-headerBg px-2 uppercase mr-4 rounded font-bold font-ptSerif text-center flex justify-center items-center'>{`${language}`}</div>
        <div className='text-grayLight flex justify-center items-center italic'>
          {file && `${file}`}
        </div>
        <div className='grow'></div>
        <Button
          onClick={() => {
            copyToClipboard(code);
            setIsCopied(true);
            setTimeout(() => setIsCopied(false), 1000);
          }}
        >
          {isCopied ? 'Copied!' : 'Copy'}
        </Button>
      </div>
      <div className='overflow-auto rounded bg-transparent'>
        <Highlight Prism={Prism as PrismLib} code={code} language={language}>
          {({ className, style, tokens, getLineProps, getTokenProps }) => (
            <pre className={`min-w-full float-left bg-black ${className}`}>
              {tokens.map((line, i) => (
                <div
                  {...getLineProps({ line, key: i })}
                  className={` ${highlights(i) ? 'bg-[#00f5c426]' : 'transparent'}`}
                >
                  <span className='flex'>
                    <span className='table-cell text-right pr-8 opacity-80 select-none'>
                      {i + 1}{' '}
                    </span>
                    <span>
                      {line.map((token, key) => (
                        <span
                          className='inline-block select-text'
                          key={key}
                          {...getTokenProps({ token, key })}
                        />
                      ))}
                    </span>
                  </span>
                </div>
              ))}
            </pre>
          )}
        </Highlight>
      </div>
    </div>
  );
};

export default Code;
